import { Link } from "react-router-dom";

const CollectionNotice = ({ children }) => (
  <p
    style={{
      margin: "8px 0 12px",
      color: "#64748b",
      fontSize: 12,
      lineHeight: 1.45,
      textAlign: "left",
    }}
  >
    {children}{" "}
    <Link to="/TermsAndConditions#privacy" target="_blank" rel="noreferrer">
      Privacy details
    </Link>
    .
  </p>
);

export default CollectionNotice;
